import { addAdditionalAccess } from '@lotushealth/lotushealth_js_sdk/endpoints';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function consumeInviteToken(token: string, signal?: AbortSignal): Promise<string> {
  const config = await createLotusRequestConfig({ signal });
  const response = await addAdditionalAccess({ token }, config);
  const data = response.data as { message: string };
  return data.message;
}
